<template>
  <div class="asc-parameter-alert--container">
    <asc-spinner-wrapper :loading="loading">
      <div class="asc-dialog--container">
        <div class="asc-dialog--top-left">
          <asc-subtitle :value="getParameterName"></asc-subtitle>
          <asc-subtitle :value="getDescription"></asc-subtitle>
          <asc-alert-descriptions-item
            class="asc-alert-descriptions-item"
            label="Alert Type"
            :value="getValue"
            :status="getAlertType"
          ></asc-alert-descriptions-item>
        </div>
        <div class="asc-dialog--top-right">
          <asc-descriptions-list :values="getDetails"></asc-descriptions-list>
        </div>
      </div>
      <div class="asc-table--container">
        <asc-subtitle value="Thresholds"></asc-subtitle>
        <asc-table
          class="asc-table"
          :definition="getTableDefinition"
        ></asc-table>
      </div>
    </asc-spinner-wrapper>
  </div>
</template>

<script>
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscSubtitle from '@/components/atoms/AscSubtitle'
import AscTable from '@/components/atoms/AscTable'
import { AscDataDefinitionMixin, AscTableMixin } from '@/components/mixins'
import * as constants from '@/utilities/appConsts'
import AscAlertDescriptionsItem from './AscAlertDescriptionsItem'
import AscDescriptionsList from './AscDescriptionsList'

export default {
  name: 'AscParameterAlert',

  components: {
    AscSubtitle,
    AscDescriptionsList,
    AscAlertDescriptionsItem,
    AscSpinnerWrapper,
    AscTable,
  },

  mixins: [AscDataDefinitionMixin, AscTableMixin],

  computed: {
    getParameterName() {
      if (this.definition && this.definition.parameterName) {
        return this.definition.parameterName
      }
      return ''
    },
    getDescription() {
      if (this.definition && this.definition.description) {
        return this.definition.description
      }
      return ''
    },
    getAlertType() {
      if (
        this.definition &&
        this.definition.details &&
        this.definition.parameterDetails &&
        this.definition.parameterDetails.status
      ) {
        return this.definition.parameterDetails.status
      }
      return constants.STATUS_VALUES.normal
    },
    getValue() {
      if (
        this.definition &&
        this.definition.details &&
        this.definition.parameterDetails &&
        this.definition.parameterDetails.value
      ) {
        return this.definition.parameterDetails.value
      }
      return ''
    },
    getDetails() {
      if (this.definition && this.definition.details) {
        return this.definition.details
      }
      return []
    },
  },
}
</script>

<style lang="scss">
.asc-parameter-alert--container {
  .asc-dialog--container {
    display: flex;
    padding: 0;
    margin: 0;
  }

  .asc-dialog--top-left {
    flex: 1;
    justify-content: start;
    background-color: $gray-100;
    padding: 25px;

    .asc-header--h3 {
      font-size: 14px;
    }
  }

  .asc-dialog--top-right {
    justify-content: flex-end;
    margin-right: 8px;
  }

  .asc-table--container {
    margin-top: 30px;

    .asc-header--h3 {
      font-size: 14px;
    }
  }

  .asc-table {
    margin: 12px 0;
    table-layout: fixed;
  }

  .asc-alert-descriptions-item {
    margin-top: 12px;
  }
}
</style>
